import React from 'react'
import { Box, Stack, Typography } from '@mui/material'
import type { UseFormWatch } from 'react-hook-form'

import { useTranslation } from '../../../../shared/hooks/useIntractionTranslate'
import type { OnboardingFormValues, OnboardingStepIndex } from '../types'
import { OnboardingReviewCard } from '../components/OnboardingReviewCard'
import { onboardingStepHintSx, onboardingStepTitleSx } from './stepStyles'

interface OrgReviewStepProps {
  /** Subscribed via `watch` so the summary stays in sync with the entered values. */
  watch: UseFormWatch<OnboardingFormValues>
  onEditStep: (step: OnboardingStepIndex) => void
}

/** Final step — read-only org summary before activation (logo row hidden for now). */
export const OrgReviewStep: React.FC<OrgReviewStepProps> = ({ watch, onEditStep }) => {
  const { t } = useTranslation()
  const values = watch()

  return (
    <Stack spacing={3}>
      <Box>
        <Typography sx={onboardingStepTitleSx}>{t('org.onboarding.stepReviewTitle')}</Typography>
        <Typography sx={onboardingStepHintSx}>{t('org.onboarding.stepReviewHint')}</Typography>
      </Box>

      <OnboardingReviewCard values={values} onEdit={onEditStep} showLogo={false} />
    </Stack>
  )
}
